const docCookies = require("mozilla-doc-cookies");
const getFetchHeaders = require("./getFetchHeaders");
const fetchAnonymousContent = require("./fetchAnonymousContent");
const getFetchAgent = require("./getFetchAgent");
const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = async function fetchAs({
	endpoint,
	headers = null,
	agent = null,
	testing = false,
	extraParams = {},
	method = "GET",
	ssr = false,
	body = null,
}) {
	let response;

	const isLoggedIn =
		typeof window !== `undefined` &&
		docCookies.hasItem("refresh_token") &&
		docCookies.hasItem("access_token");


	if (isLoggedIn) {
		response = await fetchAuthenticatedContent({
			endpoint,
			method,
			body,
			headers,
			extraParams,
		});
	} else {
		const { useDefaultJsonApiPath = true, returnResponse = false } = extraParams;
		const jsonapiBase = useDefaultJsonApiPath ? "/jsonapi" : "";
		const url = `${process.env.CLF_BACKEND_URL}${jsonapiBase}/${endpoint}`;
		let _headers = getFetchHeaders();
		if (ssr) {
			agent = getFetchAgent();
		} else if (headers) {
			_headers = { ..._headers, ...headers };
		}
		let _response = await fetchAnonymousContent(
			url,
			method,
			body,
			_headers,
			agent,
			returnResponse
		);
		if (returnResponse) {
			return _response;
		} else {
			if (_response && _response.data) {
				if (
					(Array.isArray(_response.data) && _response.data.length > 0) ||
					(!Array.isArray(_response.data) && _response.data.id) ||
					testing
				) {
					response = _response;
				}
			}
		}
	}
	return response;
};
